// extracted by mini-css-extract-plugin
module.exports = {"agency-card":"agency-card_agency-card__3SLl2","agency-card__avatar":"agency-card_agency-card__avatar__3sRlD","agency-card__icon":"agency-card_agency-card__icon__1VwX4"};